export const teachingRoleStepCopy = {
  title: "Tell us about your teaching role",
  subtitle: "This helps us tailor your ITEMA workspace.",
  nextLabel: "Next",
};

export const teachingRoles = [
  {
    id: "school-teacher",
    title: "School Teacher",
    description:
      "K-12 classroom instructions within a formal institutional framework.",
  },
  {
    id: "tutor",
    title: "Tutor",
    description:
      "Specialized 1-on-1 or small group guidance for specific subjects or exams.",
  },
  {
    id: "academic-coordinator",
    title: "Academic Coordinator",
    description:
      "Managing curriculum, educators, and broad departmental learning goals.",
  },
  {
    id: "independent-educator",
    title: "Independent Educator",
    description:
      "Running your own courses, workshops, or digital learning communities.",
  },
  {
    id: "coaching-faculty",
    title: "Coaching Faculty",
    description:
      "Preparing students for competitive exams, sports, or specialized skills.",
  },
  {
    id: "teaching-assistant",
    title: "Teaching Assistant",
    description:
      "Supporting primary educators in lesson delivery and student management.",
  },
];
